import { useCallback } from "react";
import type { BackendAxiosError } from "services/api/backendError";

interface UseExecuteSavingActionParams {
  resolveErrorMessage: (error: BackendAxiosError) => string;
  setIsSaving: (value: boolean) => void;
  setSaveError: (value: string) => void;
}

export const useExecuteSavingAction = (
  params: UseExecuteSavingActionParams,
): ((action: () => Promise<void>) => void) => {
  return useCallback(
    (action: () => Promise<void>): void => {
      params.setIsSaving(true);
      params.setSaveError("");

      action()
        .catch((error: BackendAxiosError) => {
          params.setSaveError(params.resolveErrorMessage(error));
        })
        .finally(() => {
          params.setIsSaving(false);
        });
    },
    [params],
  );
};
